import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { LandingSectionRevealDirective } from "../../shared/landing-section-reveal.directive";
import { LANDING_1_CASE_SHOWCASE_BULLETS } from "../../landing-1.section-data";

@Component({
  selector: "app-landing-1-recovery-statement",
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, LandingSectionRevealDirective],
  templateUrl: "./landing-1-recovery-statement.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1RecoveryStatementComponent {
  readonly bullets = LANDING_1_CASE_SHOWCASE_BULLETS;
}
